<!-- BLOCCO SEMPLICE -->
<div class="container-accordion-general p-3" *ngIf="block && !view" [ngClass]="{'border-title': title}">
  <div *ngIf="title">
    <p class="container-accordion-general__title-accordion ls-label-medium-semibold text-uppercase" [innerHTML]="title"></p>
  </div>
  <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion">
    <ngb-panel *ngFor="let item of block; let idx = index;" [id]="'accordion' + item.id"
      [cardClass]="acc.isExpanded('accordion' + item.id) ? 'card-body-custom' : ''">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="container-btn" [class.collapsed]="!opened">
          <button class="container-btn__button w-100 d-flex align-items-center justify-content-between text-uppercase" ngbPanelToggle
            [ngClass]="acc.isExpanded('accordion' + item.id) ? 'headerOpen' : 'headerClose'">
            <div class="ls-label-medium-semibold text-brand-40 title" [innerHTML]="item.titolo"></div>
            <div class="pe-3">
              <i aria-hidden="true" class="fa-solid fa-plus" [ngClass]="
                acc.isExpanded('accordion' + item.id) ? 'rotate-icon-45' : 'rotate-icon-0'
              "></i>
            </div>
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div *ngIf="!view" [innerHTML]="helpersService.modifyLinks(item.testo_formattato, domainWebsite) | safeHtml"></div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
<!-- END BLOCCO SEMPLICE -->
<!-- CORSO DI STUDI -->
<!-- <div class="p-3" *ngIf="block && view === 'corsoStudi'">
  <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion">
    <ngb-panel *ngFor="let item of block; let idx = index;"
      [id]="'accordion' + item.adLogID + idx"
      [cardClass]="view && acc.isExpanded('accordion' + item.adLogID + idx ) ? 'custom-accordion border-custom' : ''">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="container-btn" [class.collapsed]="!opened">
          <button class="container-btn__button w-100 d-flex align-items-center justify-content-between" ngbPanelToggle
            [ngClass]="acc.isExpanded('accordion' + item.adLogID + idx) ? 'headerOpen' : 'headerClose'">
            <div class="title" [innerHTML]="item.cds.cds_nome ? item.cds.cds_nome : item.titolo"></div>
            <div class="pe-3">
              <i class="fa-solid fa-plus" [ngClass]="
                acc.isExpanded('accordion' + item.adLogID + idx) ? 'rotate-icon-45' : 'rotate-icon-0'
              "></i>
            </div>
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
          <div class="container-accordion">
            <div class="padding-custom">
              <div class="container-accordion__table d-flex flex-wrap">
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-2">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    tipologia</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30"
                    [innerHTML]="item.cds.cds_nome">
                  </p>
                </div>
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-2">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    lingua</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30"
                    [innerHTML]="item.lingua_insegnamento"></p>
                </div>
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-2">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    Semestre</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30" [innerHTML]="item.part_descr">
                  </p>
                </div>
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-2">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    SSD</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30" [innerHTML]="item.ssd"></p>
                </div>
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-2">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    Crediti</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30" [innerHTML]="item.peso"></p>
                </div>
                <div class="container-accordion__table__item col-6 col-sm-4 col-md-1">
                  <p
                    class="container-accordion__table__item__title text-uppercase ls-label-small-semibold text-neutral-60">
                    ORE</p>
                  <p class="container-accordion__table__item__text ls-p text-neutral-30" [innerHTML]="item.ore"></p>
                </div>
              </div>
              <div class="container-accordion__description">
                <p class="ls-p text-neutral-30" [innerHTML]="item.contenuti"></p>
              </div>
            </div>
            <div class="container-accordion__container-cta d-flex flex-wrap">
              <div class="container-accordion__container-cta__item d-flex align-items-center col-12 col-lg-4">
                <div class="container-accordion__container-cta__item__icon">
                  <img loading="lazy" src="../../../../../assets/images/contenuto_corso_icon.png" alt="contenuto_corso_icon">
                </div>
                <div class="container-accordion__container-cta__item__text">
                  <p
                    class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                    Contenuti del corso</p>
                  <p class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer"
                    (click)="itemClicked({type: 'contenuti', content: item})">
                    scopri</p>
                </div>
              </div>
              <div class="container-accordion__container-cta__item d-flex align-items-center col-12 col-lg-4">
                <div class="container-accordion__container-cta__item__icon">
                  <img loading="lazy" src="../../../../../assets/images/dad_icon.png" alt="dad_icon">
                </div>
                <div class="container-accordion__container-cta__item__text">
                  <p
                    class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                    Didattica a distanza</p>
                  <p
                    class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer">
                    scopri</p>
                </div>
              </div>
              <div class="container-accordion__container-cta__item d-flex align-items-center col-12 col-lg-4">
                <div class="container-accordion__container-cta__item__icon">
                  <img loading="lazy" src="../../../../../assets/images/e-learning_icon.png" alt="e-learning_icon">
                </div>
                <div class="container-accordion__container-cta__item__text">
                  <p
                    class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                    Il corso su lumsa e-learning</p>
                  <p
                    class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer">
                    scopri</p>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div> -->
<!-- END CORSO DI STUDI -->
<!-- DOCENTE INSEGNAMENTO -->
<div class="p-3" *ngIf="block && view === 'docente'">
  <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion">
    <ngb-panel *ngFor="let item of block; let idx = index;" [id]="'accordion' + idx"
      [cardClass]="view && acc.isExpanded('accordion' + idx ) ? 'border-custom-docente' : ''">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="container-btn-docente" [class.collapsed]="!opened">
          <button class="container-btn-docente__button w-100 d-flex align-items-center justify-content-between" ngbPanelToggle
            [ngClass]="acc.isExpanded('accordion' + idx) ? 'headerOpen' : 'headerClose'">
            <div class="ls-label-medium-semibold text-brand-40 title text-uppercase" [innerHTML]="item.titolo"></div>
            <div class="pe-3">
              <i class="fa-solid fa-plus" aria-hidden="true" [ngClass]="
                acc.isExpanded('accordion' + idx) ? 'rotate-icon-45' : 'rotate-icon-0'
              "></i>
            </div>
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="container-accordion">
          <div class="padding-custom-docente">
            <div class="container-accordion__note" *ngIf="item.note_sull_insegnamento.length">
              <p class="ls-p text-neutral-30" *ngFor="let nota of item.note_sull_insegnamento" [innerHTML]="nota.value | safeHtml">
              </p>
            </div>
          </div>
          <div class="container-accordion__container-cta d-flex flex-wrap"
            [ngClass]="{'bt-custom': item.note_sull_insegnamento.length}">
            <div *ngIf="item.url_file_contenuti_corso"
              class="container-accordion__container-cta__item d-flex align-items-center {{ setColumnCTA(item) }}">
              <div class="container-accordion__container-cta__item__icon">
                <img loading="lazy" src="../../../../../assets/images/contenuto_corso_icon.png" alt="contenuto_corso_icon">
              </div>
              <div class="container-accordion__container-cta__item__text">
                <p
                  class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                  {{"BLOCK.SAMPLE_ACCORDION.COURSE_CONTENTS" | translate}}
                </p>
                <a [href]="domainWebsite + item.url_file_contenuti_corso" target="_blank" class="link-custom">
                  <p
                    class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer">
                    {{"BLOCK.SAMPLE_ACCORDION.DISCOVER" | translate}}
                  </p>
                </a>
              </div>
            </div>
            <div *ngIf="item.link_dad"
              class="container-accordion__container-cta__item d-flex align-items-center {{ setColumnCTA(item) }}">
              <div class="container-accordion__container-cta__item__icon">
                <img loading="lazy" src="../../../../../assets/images/dad_icon.png" alt="dad_icon">
              </div>
              <div class="container-accordion__container-cta__item__text">
                <p
                  class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                  {{"BLOCK.SAMPLE_ACCORDION.DISTANCE_LEARNING" | translate}}
                </p>
                <a [href]="item.link_dad" target="_blank" class="link-custom">
                  <p
                    class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer">
                    {{"BLOCK.SAMPLE_ACCORDION.DISCOVER" | translate}}
                  </p>
                </a>
              </div>
            </div>
            <div *ngIf="item.link_e_learning"
              class="container-accordion__container-cta__item d-flex align-items-center {{ setColumnCTA(item) }}">
              <div class="container-accordion__container-cta__item__icon">
                <img loading="lazy" src="../../../../../assets/images/e-learning_icon.png" alt="e-learning_icon">
              </div>
              <div class="container-accordion__container-cta__item__text">
                <p
                  class="container-accordion__container-cta__item__text__title ls-label-medium-semibold text-neutral-30 text-uppercase">
                  {{"BLOCK.SAMPLE_ACCORDION.COURSE_ON_LUMSA_ELEARNING" | translate}}
                </p>
                <a [href]="item.link_e_learning" target="_blank" class="link-custom">
                  <p
                    class="container-accordion__container-cta__item__text__button ls-label-small-semibold text-brand-40 text-uppercase m-0 cursor-pointer">
                    {{"BLOCK.SAMPLE_ACCORDION.DISCOVER" | translate}}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
<!-- END DOCENTE INSEGNAMENTO -->
<!-- DOCENTE PUBBLICAZIONI -->
<div class="p-3" *ngIf="block && view === 'docente-pub'">
  <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion">
    <ngb-panel *ngFor="let item of block; let idx = index;" [id]="'accordion' + idx"
      [cardClass]="view && acc.isExpanded('accordion' + idx ) ? 'border-custom-docente' : ''">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="container-btn" [class.collapsed]="!opened">
          <button class="container-btn__button w-100 d-flex align-items-center justify-content-between" ngbPanelToggle
            [ngClass]="acc.isExpanded('accordion' + idx) ? 'headerOpen' : 'headerClose'">
            <div class="ls-label-medium-semibold text-brand-40 title text-uppercase" [innerHTML]="'principali pubblicazioni'"></div>
            <div class="pe-3">
              <i class="fa-solid fa-plus" aria-hidden="true" [ngClass]="
                acc.isExpanded('accordion' + idx) ? 'rotate-icon-45' : 'rotate-icon-0'
              "></i>
            </div>
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="container-accordion" style="padding-left: 64px; padding-right: 102px;" [innerHTML]="item.value | safeHtml">
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
<!-- END DOCENTE PUBBLICAZIONI -->
<!-- DOCENTE RICERCA PUBBLICAZIONI -->
<div class="p-3" *ngIf="block && view === 'docente-ric-pub'">
  <ngb-accordion [closeOthers]="true" [destroyOnHide]="true" [animation]="true" #acc="ngbAccordion"
    id="ngbAccordion-docente-ric">
    <ngb-panel *ngFor="let item of block; let idx = index;" [id]="'accordion' + idx"
      [cardClass]="view && acc.isExpanded('accordion' + idx ) ? 'border-custom-docente' : ''">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="container-btn-docente-ric" [class.collapsed]="!opened">
          <button class="container-btn-docente-ric__button w-100 d-flex align-items-center justify-content-between"
            ngbPanelToggle [ngClass]="acc.isExpanded('accordion' + idx) ? 'headerOpen-docente-ric' : 'headerClose'">
            <div *ngIf="item.title" class="ls-label-medium-semibold text-neutral-30 title" [innerHTML]="item.title"></div>
            <div class="pe-3">
              <i class="fa-solid fa-plus" aria-hidden="true" [ngClass]="
                acc.isExpanded('accordion' + idx) ? 'rotate-icon-45' : 'rotate-icon-0'
              "></i>
            </div>
          </button>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="container-accordion" style="padding-left: 64px; padding-right: 102px;">
          <div *ngIf="item.description" [innerHTML]="item.description | safeHtml"></div>
          <!-- <div class="mt-3" *ngIf="item.author" [innerHTML]="item.author"></div> -->
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
<!-- END DOCENTE RICERCA PUBBLICAZIONI -->